(() => {
  'use strict';
  if (!document.body.classList.contains('template-index')) return;
  const targets = new Set(['#hero06', '#hero07']);
  const MAX_MS = 20000, MAX_CHECKS = 80, MAX_SCROLLS = 8;
  let job = null, timer = 0;
  const locked = () => [document.documentElement, document.body].some(el => {
    const css = getComputedStyle(el);
    return ['hidden', 'clip'].includes(css.overflowY) || css.position === 'fixed' ||
      /(?:^|\s)(?:modal-open|modal-closing|js-drawer-open)(?:\s|$)/.test(el.className);
  });
  function stop() { clearTimeout(timer); job = null; }
  function tick() {
    if (!job) return;
    const age = performance.now() - job.started;
    if (age >= MAX_MS || ++job.checks > MAX_CHECKS || location.hash !== job.hash) return stop();
    const el = document.getElementById(job.hash.slice(1));
    if (locked() || !el || !el.getClientRects().length) {
      job.stable = 0;
    } else {
      const top = el.getBoundingClientRect().top + window.scrollY;
      job.stable = Math.abs(top - job.lastTop) < 1 ? job.stable + 1 : 0;
      job.lastTop = top;
      // Let normal loading settle, but never wait indefinitely on a third party.
      const ready = (document.readyState === 'complete' &&
        (!document.fonts || document.fonts.status === 'loaded')) || age >= 5000;
      const maxY = Math.max(0, document.documentElement.scrollHeight - innerHeight);
      if (ready && job.stable >= 2 && Math.abs(scrollY - Math.min(top, maxY)) > 2) {
        el.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'nearest' });
        if (++job.scrolls >= MAX_SCROLLS) return stop();
      }
    }
    timer = setTimeout(tick, 250);
  }
  function start() {
    stop();
    if (!targets.has(location.hash)) return;
    job = { hash: location.hash, started: performance.now(), checks: 0, scrolls: 0, stable: 0, lastTop: NaN };
    tick();
  }
  function anchor(event) {
    const link = event.target instanceof Element && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return false;
    const url = new URL(link.href, location.href);
    return url.origin === location.origin && url.pathname === location.pathname &&
      url.search === location.search && targets.has(url.hash);
  }
  function input(event) {
    if (!job) return;
    // Closing/accepting a modal must still allow the pending destination on unlock.
    // Gestures inside a locked modal never move the background page.
    if (locked()) return;
    if (event.type === 'pointerdown' && anchor(event)) return;
    stop();
  }
  for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
    document.addEventListener(type, input, { capture: true, passive: true });
  }
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (anchor(event)) setTimeout(start, 0); // Includes clicking the already-current hash.
  });
  window.addEventListener('hashchange', start);
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', event => { if (event.persisted) start(); });
  start();
})();
